import { defineComponent, h } from 'vue';
import { QBtn, QIcon } from 'quasar';
import utils from "../../Shared/utils.jsx";
import BaseComponent from "./BaseComponentMixin.jsx";
import { appSettings } from "../../Shared/appSettings.js";
import { outlinePrimaryQBtnClassNames } from '../../Shared/buttonAppearance.js';
import TranslationContainer from './TranslationContainer.jsx';
import './css/BasicButton.css';

export default defineComponent({
    name: 'apple-button',
    components: { QBtn, QIcon, TranslationContainer },
    mixins: [BaseComponent],
    data: function() {
        return {};
    },
    computed: {
        styles() {
            return {
                ...this.sizeStyle,
                ...utils.resolveStyleHints(this.styleHints, this),
            };
        },
    },

    //Created replaced with preRenderComplete
    methods: {
        async preRenderComplete() {
            this.startAppleApp();

            this.finishRenderHandler(this);
        },
        startAppleApp() {
            const appleId = appSettings.WhiteLabel.AppleSigninId;

            if (!appleId) return;

            AppleID.auth.init({
                clientId: appleId,
                scope: "email",
                redirectURI: window.location.origin,
                usePopup: true,
            });
        },
        async handleClick() {
            try {
                const result = await AppleID.auth.signIn({
                    clientId: appSettings.WhiteLabel.AppleSigninId,
                    scope: "email",
                    redirectURI: window.location.origin,
                    //state: '[STATE]',
                    //nonce: '[NONCE]',
                    usePopup: true,
                });

                const authArgs = {
                    ProviderType: "Apple",
                    token: result.authorization.id_token, // JWT (JSON Web Token)
                    clientId: appSettings.WhiteLabel.AppleSigninId,
                };

                await this.runActions(authArgs);
            } catch (err) {}
        },
        async runActions(authArgs) {
            await utils.executeAndCompileAllActions(this.controlData.Actions, authArgs, this);
        },
    },
    render() {
        try {
            if (!this.todisplay) return null;

            return (
                <div
                    style={this.styles}
                    class={{ "c-AppleButton flex": true, [`c-name-${this.name || "unnamed"}`]: true }}
                >
                    <QBtn
                        color="primary"
                        outline
                        no-caps
                        size="14px"
                        full-width
                        align="center"
                        class={outlinePrimaryQBtnClassNames({ useLiteralCasing: true })}
                        onClick={this.handleClick}
                        style="width: 100%;"
                    >
                        <QIcon name="mdi-apple" style={{ marginRight: '10px' }} size="20px" />
                        <TranslationContainer context={this} value="Sign in with Apple" />
                    </QBtn>
                </div>
            );
        } catch (e) {
            utils.error("AppleButton Render failed", e);
            return <div>AppleButton Failed to Render {e}</div>;
        }
    },
});
